import React from 'react';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { Button } from '@michelin/acid-components';
import { useTranslation } from 'react-i18next';
import Oauth from '../../providers/Auth0Provider/Auth0Provider';
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid } from '@material-ui/core';
export default function SessionExpiredPopup() {
    var t = useTranslation().t;
    return (React.createElement(Dialog, { "aria-labelledby": "customized-dialog-title", open: true, fullWidth: true, maxWidth: 'xs' },
        React.createElement(DialogTitle, null, t('Session Expired')),
        React.createElement(DialogContent, null,
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 2, md: 1, lg: 1 },
                    React.createElement(AccessTimeIcon, { color: "primary" })),
                React.createElement(Grid, { item: true, xs: 10, md: 11, lg: 11 },
                    t('Your session is no longer available'),
                    ".")),
            React.createElement(Grid, { container: true },
                React.createElement("p", null,
                    " ",
                    t('You will be redirected to the login page'),
                    ". "))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { variant: "contained", size: "small", color: "primary", onClick: function () { return Oauth.logout(); } }, t('OK')))));
}
;
//# sourceMappingURL=SessionExpiredPopup.js.map